module.exports = __webpack_public_path__ + "img/titulo-dorso.c52f5bec.png";